import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Blob } from '@/components/generals/blob'

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('relative inline-flex items-center pr-3 font-heading text-[1.7rem] leading-none tracking-wide text-plum uppercase', className)}>
            Huzzah

            <Blob
                shape='burst'
                className='absolute -top-1.5 -right-1 size-4 text-coral motion-safe:animate-spin-slow'
            />
        </span>
    )
}
